import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { SketchPicker, ChromePicker } from 'react-color';
import { ReactTags } from 'react-tag-autocomplete';
import DatePicker from 'react-datepicker';
import DateTime from 'react-datetime';
import Select from 'react-select';
import InputMask from '@mona-health/react-input-mask';
import ReactQuill from 'react-quill-new';
import 'quill/dist/quill.snow.css';
import 'react-datetime/css/react-datetime.css';
import 'react-datepicker/dist/react-datepicker.css';
import Highlight from 'react-highlight';
import useTemplateInteractions from './../../composables/templateInteractions.js';

function FormPlugins() {
	const [code1, setCode1] = useState();
	const [code2, setCode2] = useState();
	const [code3, setCode3] = useState();
	const [code4, setCode4] = useState();
	const [code5, setCode5] = useState();
	const [code6, setCode6] = useState();
	const [code7, setCode7] = useState();

	const [maxDateDisabled, setMaxDateDisabled] = useState(true);
	const [maxDate, setMaxDate] = useState(null);
	const [startDate, setStartDate] = useState(new Date());
	const [sketchBackgroundColor, setSketchBackgroundColor] = useState('#348fe2');
	const [chromeBackgroundColor, setChromeBackgroundColor] = useState('#8753de');
	const [tags, setTags] = useState([
		{ value: 1, label: 'Apples' },
		{ value: 2, label: 'Pears' }
	]);
	const [suggestions] = useState([
		{ value: 1, label: 'Apples' },
		{ value: 2, label: 'Pears' },
		{ value: 3, label: 'Bananas' },
		{ value: 4, label: 'Mangos' },
		{ value: 5, label: 'Lemons' },
		{ value: 6, label: 'Apricots' }
	]);
	const [text, setText] = useState('');
	const [sliderValue, setSliderValue] = useState(3);
	const [fixedSliderValue, setFixedSliderValue] = useState(20);
	const [rangeValues, setRangeValues] = useState([3, 10]);
	const [openColorPicker, setOpenColorPicker] = useState(null);

	const minDateRange = (current) => {
		return current.isAfter(DateTime.moment().subtract(1, 'day'));
	};

	const maxDateRange = (current) => {
		return !maxDate || current.isAfter(maxDate);
	};

	const minDateChange = (value) => {
		setMaxDateDisabled(false);
		setMaxDate(value);
	};

	const handleDateChange = (date) => {
		setStartDate(date);
	};

	const handleQuillChange = (value) => {
		setText(value);
	};

	const handleSketchChangeComplete = (color) => {
		setSketchBackgroundColor(color.hex);
	};

	const handleChromeChangeComplete = (color) => {
		setChromeBackgroundColor(color.hex);
	};

	const handleColorPickerToggle = (picker) => {
		setOpenColorPicker((current) => (current === picker ? null : picker));
	};

	const handleDelete = useCallback(
		(tagIndex) => {
			setTags(tags.filter((_, i) => i !== tagIndex));
		},
		[tags]
	);

	const handleAdd = (newTag) => {
		setTags([...tags, newTag]);
	};

	const selectOptions = [
		{ value: 'chocolate', label: 'Chocolate' },
		{ value: 'strawberry', label: 'Strawberry' },
		{ value: 'vanilla', label: 'Vanilla' }
	];

	const selectStyles = {
		control: (styles, state) => ({
			...styles,
			backgroundColor: 'var(--bs-component-bg)',
			borderColor: state.isFocused ? 'var(--bs-primary)' : 'var(--bs-component-border-color)',
			boxShadow: 'none',
			minHeight: '38px'
		}),
		menu: (styles) => ({ ...styles, backgroundColor: 'var(--bs-component-dropdown-bg)', zIndex: 5 }),
		option: (styles, state) => ({
			...styles,
			backgroundColor: state.isFocused ? 'var(--bs-component-dropdown-hover-bg)' : 'transparent',
			color: 'var(--bs-component-color)',
			cursor: state.isDisabled ? 'not-allowed' : 'pointer'
		}),
		input: (styles) => ({ ...styles, color: 'var(--bs-component-color)' }),
		singleValue: (styles) => ({ ...styles, color: 'var(--bs-component-color)' }),
		placeholder: (styles) => ({ ...styles, color: 'rgba(var(--bs-component-color-rgb), .5)' })
	};

	useEffect(() => {
		fetch('/color-admin/admin/react/assets/data/form-plugins/code-1.json')
			.then(function (response) {
				return response.text();
			})
			.then((html) => {
				setCode1(html);
			});
		fetch('/color-admin/admin/react/assets/data/form-plugins/code-2.json')
			.then(function (response) {
				return response.text();
			})
			.then((html) => {
				setCode2(html);
			});
		fetch('/color-admin/admin/react/assets/data/form-plugins/code-3.json')
			.then(function (response) {
				return response.text();
			})
			.then((html) => {
				setCode3(html);
			});
		fetch('/color-admin/admin/react/assets/data/form-plugins/code-4.json')
			.then(function (response) {
				return response.text();
			})
			.then((html) => {
				setCode4(html);
			});
		fetch('/color-admin/admin/react/assets/data/form-plugins/code-5.json')
			.then(function (response) {
				return response.text();
			})
			.then((html) => {
				setCode5(html);
			});
		fetch('/color-admin/admin/react/assets/data/form-plugins/code-6.json')
			.then(function (response) {
				return response.text();
			})
			.then((html) => {
				setCode6(html);
			});
		fetch('/color-admin/admin/react/assets/data/form-plugins/code-7.json')
			.then(function (response) {
				return response.text();
			})
			.then((html) => {
				setCode7(html);
			});
	}, []);

	const rootRef = useRef(null);
	useTemplateInteractions(rootRef);

	return (
		<div ref={rootRef}>
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-xl-10">
						<div className="row">
							<div className="col-xl-9">
								<ul className="breadcrumb">
									<li className="breadcrumb-item">
										<Link to="/form/plugins">Form Stuff</Link>
									</li>
									<li className="breadcrumb-item active"></li>
								</ul>
								<h1 className="page-header">
									Form Plugins <small>page header description goes here...</small>
								</h1>
								<hr className="mb-4" />
								<div id="bootstrapDateTimePicker" className="mb-5">
									<h4>Bootstrap date time picker</h4>
									<p>
										Date and time selection controls with default, time-only, and range picker
										states. Please read the{' '}
										<a
											href="https://github.com/arqex/react-datetime"
							target="_blank"
											rel="noopener noreferrer"
										>
											official documentation
										</a>{' '}
										for the full list of options.
									</p>
									<div className="card">
										<div className="card-body">
											<form>
												<div className="row g-3">
													<div className="col-lg-6">
														<label className="form-label">Default Date Time</label>
														<DateTime
															inputProps={{ placeholder: 'Datepicker' }}
															closeOnSelect={true}
														/>
													</div>
													<div className="col-lg-6">
														<label className="form-label">Select Time</label>
														<DateTime
															dateFormat={false}
															inputProps={{ placeholder: 'Timepicker' }}
														/>
													</div>
													<div className="col-lg-6">
														<label className="form-label">Range Pickers</label>
														<div className="row gx-2">
															<div className="col-6">
																<DateTime
																	isValidDate={minDateRange}
																	inputProps={{ placeholder: 'Min Date' }}
																	closeOnSelect={true}
																	onChange={minDateChange}
																/>
															</div>
															<div className="col-6">
																<DateTime
																	isValidDate={maxDateRange}
																	inputProps={{
																		placeholder: 'Max Date',
																		disabled: maxDateDisabled
																	}}
																	closeOnSelect={true}
																/>
															</div>
														</div>
													</div>
												</div>
											</form>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<Highlight className="typescript">{code1}</Highlight>
										</div>
									</div>
								</div>
								<div id="reactSelect" className="mb-5">
									<h4>React Select</h4>
									<p>
										A searchable React select control with theme-aware styling and a native form
										layout. Please read the{' '}
										<a href="https://react-select.com/" target="_blank" rel="noopener noreferrer">
											official documentation
										</a>{' '}
										for the full list of options.
									</p>
									<div className="card">
										<div className="card-body">
											<form>
												<div className="row g-3">
													<div className="col-lg-6">
														<label className="form-label">React Select Dropdown</label>
														<Select
															options={selectOptions}
															styles={selectStyles}
															classNamePrefix="react-select"
														/>
													</div>
												</div>
											</form>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<Highlight className="typescript">{code2}</Highlight>
										</div>
									</div>
								</div>
								<div id="datepicker" className="mb-5">
									<h4>Datepicker</h4>
									<p>
										A standard datepicker and inline datepicker using the current React
										implementation. Please read the{' '}
										<a
											href="https://reactdatepicker.com/"
							target="_blank"
											rel="noopener noreferrer"
										>
											official documentation
										</a>{' '}
										for the full list of options.
									</p>
									<div className="card">
										<div className="card-body">
											<form>
												<div className="row g-3">
													<div className="col-lg-6">
														<label className="form-label">Default Datepicker</label>
														<DatePicker
															selected={startDate}
															onChange={handleDateChange}
															className="form-control"
														/>
													</div>
													<div className="col-lg-6">
														<label className="form-label">Inline Datepicker</label>
														<DatePicker
															inline
															selected={startDate}
															onChange={handleDateChange}
														/>
													</div>
												</div>
											</form>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<Highlight className="typescript">{code3}</Highlight>
										</div>
									</div>
								</div>
								<div id="reactInputMask" className="mb-5">
									<h4>React Input Mask</h4>
									<p>
										Input masks for dates, phone numbers, tax IDs, product keys, and social security
										numbers. Please read the{' '}
										<a
											href="https://github.com/mona-health/react-input-mask"
							target="_blank"
											rel="noopener noreferrer"
										>
											official documentation
										</a>{' '}
										for the full list of options.
									</p>
									<div className="card">
										<div className="card-body">
											<form>
												<div className="row g-3">
													<div className="col-lg-6">
														<label className="form-label">Date</label>
														<InputMask
															mask="9999/99/99"
															className="form-control"
															placeholder="yyyy/mm/dd"
														></InputMask>
													</div>
													<div className="col-lg-6">
														<label className="form-label">Phone</label>
														<InputMask
															mask="(999) 999-999"
															className="form-control"
															placeholder="(999) 999-9999"
														></InputMask>
													</div>
													<div className="col-lg-6">
														<label className="form-label">Tax ID</label>
														<InputMask
															mask="99-999999"
															className="form-control"
															placeholder="99-9999999"
														></InputMask>
													</div>
													<div className="col-lg-6">
														<label className="form-label">Product Key</label>
														<InputMask
															mask="a\*-999-a999"
															className="form-control"
															placeholder="a*-999-a999"
														></InputMask>
													</div>
													<div className="col-lg-6">
														<label className="form-label">SSN</label>
														<InputMask
															mask="999/99/9999"
															className="form-control"
															placeholder="999/99/9999"
														></InputMask>
													</div>
													<div className="col-lg-6">
														<label className="form-label">SSN</label>
														<InputMask
															mask="AAA-1111-A"
															className="form-control"
															placeholder="AAA-9999-A"
														></InputMask>
													</div>
												</div>
											</form>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<Highlight className="typescript">{code4}</Highlight>
										</div>
									</div>
								</div>
								<div id="reactColorpicker" className="mb-5">
									<h4>React Colorpicker</h4>
									<p>
										Interactive Sketch and Chrome color pickers with live color values. Please read
										the{' '}
										<a
											href="https://casesandberg.github.io/react-color/"
							target="_blank"
											rel="noopener noreferrer"
										>
											official documentation
										</a>{' '}
										for the full list of options.
									</p>
									<div className="card">
										<div className="card-body">
											<form>
												<div className="row g-3">
													<div className="col-lg-6">
														<label className="form-label">Sketch Type Colorpicker</label>
														<div className="input-group">
															<input
																type="text"
																className="form-control bg-white"
																readOnly
																value={sketchBackgroundColor}
															/>
															<span className="input-group-text">
																<button
																	type="button"
																	aria-label="Open sketch color picker"
																	onClick={() => handleColorPickerToggle('sketch')}
																	className="btn btn-link p-0 border-0"
																>
																	<i
																		style={{
																			width: '16px',
																			height: '16px',
																			display: 'block',
																			background: sketchBackgroundColor
																		}}
																	></i>
																</button>
																<div
																	className={
																		'dropdown-menu' +
																		(openColorPicker === 'sketch' ? ' show' : '')
																	}
																	style={{ zIndex: 5 }}
																>
																	<SketchPicker
																		color={sketchBackgroundColor}
																		onChangeComplete={handleSketchChangeComplete}
																	/>
																</div>
															</span>
														</div>
													</div>
													<div className="col-lg-6">
														<label className="form-label">Chrome Type Colorpicker</label>
														<div className="input-group">
															<input
																type="text"
																className="form-control bg-white"
																readOnly
																value={chromeBackgroundColor}
															/>
															<span className="input-group-text">
																<button
																	type="button"
																	aria-label="Open chrome color picker"
																	onClick={() => handleColorPickerToggle('chrome')}
																	className="btn btn-link p-0 border-0"
																>
																	<i
																		style={{
																			width: '16px',
																			height: '16px',
																			display: 'block',
																			background: chromeBackgroundColor
																		}}
																	></i>
																</button>
																<div
																	className={
																		'dropdown-menu' +
																		(openColorPicker === 'chrome' ? ' show' : '')
																	}
																	style={{ zIndex: 5 }}
																>
																	<ChromePicker
																		color={chromeBackgroundColor}
																		onChangeComplete={handleChromeChangeComplete}
																	/>
																</div>
															</span>
														</div>
													</div>
												</div>
											</form>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<Highlight className="typescript">{code5}</Highlight>
										</div>
									</div>
								</div>
								<div id="reactSlider" className="mb-5">
									<h4>React Slider</h4>
									<p>
										Range controls with default, fixed-step, and custom range values. Please read
										the{' '}
										<a
											href="https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/input/range"
							target="_blank"
											rel="noopener noreferrer"
										>
											official documentation
										</a>{' '}
										for the full list of options.
									</p>
									<div className="card">
										<div className="card-body">
											<form>
												<div className="row g-3">
													<div className="col-lg-6">
														<label className="form-label">Default Slider</label>
														<input
															type="range"
															className="form-range"
															min="0"
															max="20"
															value={sliderValue}
															onChange={(event) =>
																setSliderValue(Number(event.target.value))
															}
														/>
														<div className="small text-body-secondary">
															Value: {sliderValue}
														</div>
													</div>
													<div className="col-lg-6">
														<label className="form-label">Slider with fixed values</label>
														<input
															type="range"
															className="form-range"
															min="20"
															max="100"
															step="20"
															value={fixedSliderValue}
															onChange={(event) =>
																setFixedSliderValue(Number(event.target.value))
															}
														/>
														<div className="d-flex justify-content-between small text-body-secondary">
															<span>20</span>
															<span>40</span>
															<span>60</span>
															<span>80</span>
															<span>100</span>
														</div>
														<div className="small text-body-secondary">
															Value: {fixedSliderValue}
														</div>
													</div>
													<div className="col-lg-6">
														<label className="form-label">Range with custom handle</label>
														<div className="d-flex align-items-center gap-2">
															<input
																aria-label="Range start"
																type="range"
																className="form-range"
																min="0"
																max="20"
																value={rangeValues[0]}
																onChange={(event) =>
																	setRangeValues([
																		Math.min(
																			Number(event.target.value),
																			rangeValues[1]
																		),
																		rangeValues[1]
																	])
																}
															/>
															<input
																aria-label="Range end"
																type="range"
																className="form-range"
																min="0"
																max="20"
																value={rangeValues[1]}
																onChange={(event) =>
																	setRangeValues([
																		rangeValues[0],
																		Math.max(
																			Number(event.target.value),
																			rangeValues[0]
																		)
																	])
																}
															/>
														</div>
														<div className="small text-body-secondary">
															Range: {rangeValues[0]} - {rangeValues[1]}
														</div>
													</div>
												</div>
											</form>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<Highlight className="typescript">
												{
													'import React, { useState } from \'react\'; const [value, setValue] = useState(3); <input type="range" min="0" max="20" value={value} onChange={event => setValue(Number(event.target.value))} />'
												}
											</Highlight>
										</div>
									</div>
								</div>
								<div id="reactQuill" className="mb-5">
									<h4>React Quill</h4>
									<p>
										A rich text editor with editable content and the current Quill configuration.
										Please read the{' '}
										<a
											href="https://github.com/VaguelySerious/react-quill"
							target="_blank"
											rel="noopener noreferrer"
										>
											official documentation
										</a>{' '}
										for the full list of options.
									</p>
									<div className="card">
										<div className="card-body">
											<div className="pb-2px">
												<ReactQuill
													value={text}
													onChange={handleQuillChange}
													className="h-200px mb-40px"
												/>
											</div>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<Highlight className="typescript">{code6}</Highlight>
										</div>
									</div>
								</div>
								<div id="reactTagsInput" className="mb-5">
									<h4>React Tags Input</h4>
									<p>
										Tag entry with autocomplete suggestions, add, and delete interactions. Please
										read the{' '}
										<a
											href="https://github.com/i-like-robots/react-tag-autocomplete"
							target="_blank"
											rel="noopener noreferrer"
										>
											official documentation
										</a>{' '}
										for the full list of options.
									</p>
									<div className="card">
										<div className="card-body">
											<form>
												<div className="row g-3">
													<div className="col-lg-6">
														<label className="form-label">Default Input Tag</label>
														<ReactTags
															selected={tags}
															suggestions={suggestions}
															onDelete={handleDelete}
															onAdd={handleAdd}
														/>
													</div>
												</div>
											</form>
										</div>
										<div
											className="hljs-container hljs-wrapper rounded-0 rounded-bottom"
											data-bs-theme="dark"
										>
											<Highlight className="typescript">{code7}</Highlight>
										</div>
									</div>
								</div>
							</div>
							<div className="col-xl-3">
								<nav
									data-init="scrollspy"
									className="navbar navbar-sticky navbar-sticky-start d-none d-xl-block py-4 h-100"
								>
									<nav className="nav text-nowrap">
										<a className="nav-link" href="#bootstrapDateTimePicker" data-toggle="scroll-to">
											Bootstrap date time picker
										</a>
										<a className="nav-link" href="#reactSelect" data-toggle="scroll-to">
											React Select
										</a>
										<a className="nav-link" href="#datepicker" data-toggle="scroll-to">
											Datepicker
										</a>
										<a className="nav-link" href="#reactInputMask" data-toggle="scroll-to">
											React Input Mask
										</a>
										<a className="nav-link" href="#reactColorpicker" data-toggle="scroll-to">
											React Colorpicker
										</a>
										<a className="nav-link" href="#reactSlider" data-toggle="scroll-to">
											React Slider
										</a>
										<a className="nav-link" href="#reactQuill" data-toggle="scroll-to">
											React Quill
										</a>
										<a className="nav-link" href="#reactTagsInput" data-toggle="scroll-to">
											React Tags Input
										</a>
									</nav>
								</nav>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default FormPlugins;
